import React from 'react';

const MarkerPopup = ({st}) => {
    return (
        <div id="MarkerPopup" className="markerPopup">
            <table className="table table-bordered">
                <thead>
                <tr>
                    <td colSpan={2}>{st.nomi}</td>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Sarf</td>
                    <td>{st.volume}</td>
                </tr>
                <tr>
                    <td>Sath</td>
                    <td>{st.level}</td>
                </tr>
                <tr>
                    <td>Sana</td>
                    <td style={{minWidth:'50px'}}>{st.sana}</td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};
export default MarkerPopup;